<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <!-- <div class="header-top container-fuild hidden-xs">
      <div class="container"> -->
    <!-- <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>888-888-888
          <span class="glyphicon glyphicon-envelope"></span>xxx@163.com
          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！
          <span class="glyphicon glyphicon-hand-left"></span>
        </div> -->

    <!-- </div>
    </div> -->
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/logo.png" width="50" height="50" />
      </div>
      <div class="header-nav-title">
        <p>AICartoonGenerator</p>
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item, index) in navList"
          :key="index"
          :class="index == navIndex ? 'active' : ''"
          @click="navClick(index, item.name)"
        >
          <router-link :to="item.path">
            {{ item.name }}
            <span
              v-if="item.children.length > 0"
              class="glyphicon glyphicon-menu-down"
            ></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length > 0">
            <dt v-for="(i, n) in item.children" :key="n">
              <router-link :to="i.path">{{ i.name }}</router-link>
            </dt>
          </dl>
        </li>
        <li style="height: 60px">
          <div class="lang">
            <el-dropdown @command="langChange">
              <span class="el-dropdown-link">
                {{ $i18n.locale == "zh" ? "中文" : "English"
                }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="zh" :disabled="$i18n.locale == 'zh'"
                  >中文</el-dropdown-item
                >
                <el-dropdown-item command="en" :disabled="$i18n.locale == 'en'"
                  >English</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </li>
        <li>
          <el-button size="medium" @click="signIn">{{ $t("Header.btn1") }}</el-button>
        </li>
        <li>
          <el-button size="medium" type="primary" @click="signUp">{{ $t("Header.btn2") }}</el-button>
        </li>
        <li>
          <el-button size="medium"  @click="goCoffee"
            >By me a coffee</el-button
          >
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/img/logo.png" width="32" height="32" alt="logo" />
        <div style="padding:15px">
            <div class="lang">
            <el-dropdown @command="langChange">
              <span class="el-dropdown-link">
                {{ $i18n.locale == "zh" ? "中文" : "English"
                }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="zh" :disabled="$i18n.locale == 'zh'"
                  >中文</el-dropdown-item
                >
                <el-dropdown-item command="en" :disabled="$i18n.locale == 'en'"
                  >English</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          </div>
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{ menuName }}
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item, index) in navList2"
            :key="index"
            :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              {{ item.name }}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: "Home",
      menuClass: "glyphicon glyphicon-menu-down",
      navList2: [
        {
          name: "首页",
          path: "/",
          children: [],
        },
        {
          name: "特征",
          path: "",
          children: [],
        },
        {
          name: "博客",
          path: "/Blog",
          children: [],
        },
        {
          name: "联系我们",
          path: "/contactus",
          children: [],
        },
        {
          name: "Privacy Policy",
          path: "/PrivacyPolicy",
        },
        {
          name: "Terms of use",
          path: "/TermsOfUse",
        },
        {
          name: "Sign In",
          path: "/Login",
        },
        {
          name: "Sign Up",
          path: "/SignUp",
        },
        {
          name: "By me a coffee",
          path:""
        },
      ],
      navList: [
        {
          name: "首页",
          path: "/",
          children: [],
        },
        {
          name: "特征",
          path: "",
          children: [],
          // path: "/software",
          // children: [
          //   {
          //     name: "智能小镇管理系统",
          //     path: "/software/smartTown"
          //   },
          //   {
          //     name: "大数据管理系统",
          //     path: "/software/bigData"
          //   }
          // ]
        },
        {
          name: "博客",
          path: "/Blog",
          children: [],
        },
        {
          name: "联系我们",
          path: "/contactus",
          children: [],
        },
        {
          name: "更多",
          // path: "/companyintroduction",
          path: "",
          children: [
            {
              name: "Privacy Policy",
              path: "/PrivacyPolicy",
            },
            {
              name: "Terms of use",
              path: "/TermsOfUse",
            },
          ],
        },
        // {
        //   name: "特征",
        //   path: "/jobchance",
        //   children: []
        // },
        // {
        //   name: "联系我们",
        //   path: "/contactus",
        //   children: []
        // }
      ],
    };
  },
  created() {
    this.updateList();
  },
  methods: {
     goCoffee(){
      window.location.href = "https://ko-fi.com/handsometong"
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = name;
      if (name == "Features") {
        this.$router.push({
          name: "home",
        });
        setTimeout(() => {
          this.scrollToTarget();
        }, 100);
      }
      if (name == "特性") {
        this.$router.push({
          name: "home",
        });
        setTimeout(() => {
          this.scrollToTarget();
        }, 100);
      }
      if (name == "By me a coffee") {
        this.goCoffee()
      }
    },
    menuClick(menuName) {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    langChange(command) {
      this.$i18n.locale = command;
      localStorage.setItem("lang", command);
      if (command == "en") {
        this.language = "English";
      } else if (command == "zh") {
        this.language = "中文";
      }
      this.updateList();
    },
    updateList() {
      this.navList[0].name = this.$t("Header.nav1");
      this.navList[1].name = this.$t("Header.nav2");
      this.navList[2].name = this.$t("Header.nav3");
      this.navList[3].name = this.$t("Header.nav4");
      this.navList[4].name = this.$t("Header.nav5");
      this.navList[4].children[0].name = this.$t("Header.nav6")
      this.navList[4].children[1].name = this.$t("Header.nav7")
      this.navList2[0].name = this.$t("Header.nav1");
      this.navList2[1].name = this.$t("Header.nav2");
      this.navList2[2].name = this.$t("Header.nav3");
      this.navList2[3].name = this.$t("Header.nav4");
      this.navList2[4].name = this.$t("Header.nav6");
      this.navList2[5].name = this.$t("Header.nav7");
      this.navList2[6].name = this.$t("Header.nav8");
      this.navList2[7].name = this.$t("Header.nav9");
    },
    scrollToTarget() {
      var targetElement = document.getElementById("Features");
      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
    signIn(){
      this.$router.push({
          path: "Login",
        });
    },
    signUp(){
      this.$router.push({
          path: "SignUp",
        });
    }
  },
};
</script>
<style scoped>
.el-dropdown {
  /* color: #fff; */
  float: right;
  height: 60px;
}
/* 顶部 */
#header {
  background: #f4f4f4;
  transition: all ease 0.6s;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 110px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 100px;
  height: 100%;
  float: left;
  position: relative;
}
.header-nav-title {
  /* width: 150px; */
  height: 100%;
  float: left;
  position: relative;
}
.header-nav-title p {
  font-size: 18px;
  line-height: 110px;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  /* width: 95px;
  height: 45px; */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  float: left;
  margin: 0;
  padding-left: 20px;
  max-width: 1000px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 10px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #000;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1e73be;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #1e73be;
  text-decoration: none;
  border-bottom: 2px solid #1e73be;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
@media screen and (max-width: 997px) {
  .el-dropdown {
  /* color: #fff; */
  float: left;
  height: 20px;
}
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    object-fit: scale-down;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav-m .header-nav-m-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav-m .header-nav-m-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav-m .header-nav-m-wrapper > li > dl > dt > a:visited {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav-m .header-nav-m-wrapper > li:visited dl {
  display: block;
}
#header .header-nav-m .header-nav-m-wrapper > li > dl > dt:visited {
  cursor: pointer;
  background: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue